import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { TRACTION } from "@/lib/content";

export default function Traction() {
    return (
        <section
            id="traction"
            className="relative border-t border-white/10 bg-navy-900"
            data-testid="traction"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                <Reveal>
                    <SectionLabel index="04">Traction</SectionLabel>
                </Reveal>

                <div className="grid gap-12 md:grid-cols-12 md:items-end">
                    <div className="md:col-span-7">
                        <Reveal delay={0.1}>
                            <h2 className="font-display text-3xl md:text-5xl font-light leading-tight tracking-tight text-white">
                                Ten things already{" "}
                                <span className="italic text-gold">
                                    in place
                                </span>{" "}
                                before this raise.
                            </h2>
                        </Reveal>
                    </div>
                    <div className="md:col-span-5">
                        <Reveal delay={0.2}>
                            <p className="text-base md:text-lg leading-relaxed text-white/70">
                                Company, banking, product, distribution, and
                                program infrastructure are live and generating
                                signal. This capital accelerates a machine that
                                is already running.
                            </p>
                        </Reveal>
                    </div>
                </div>

                {/* Numbered ready-today grid */}
                <StaggerGroup className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-2">
                    {TRACTION.map((item, i) => (
                        <StaggerItem key={item.title}>
                            <div className="group flex h-full items-start gap-6 bg-navy-950 p-7 transition-colors duration-300 hover:bg-navy-900 md:p-8">
                                <span className="shrink-0 font-mono text-xs tracking-[0.2em] text-gold">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div>
                                    <p className="font-display text-lg md:text-xl font-light text-white">
                                        {item.title}
                                    </p>
                                    <p className="mt-2 text-sm md:text-[15px] leading-relaxed text-white/65">
                                        {item.body}
                                    </p>
                                </div>
                            </div>
                        </StaggerItem>
                    ))}
                </StaggerGroup>

                {/* Key insight — full width */}
                <Reveal delay={0.15}>
                    <div className="mt-10 border border-gold/25 bg-gold/[0.04] p-8 md:p-12">
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Key Insight
                        </p>
                        <p className="mt-6 max-w-4xl font-display text-2xl md:text-3xl font-light leading-snug text-white">
                            The majority of people who are married or have
                            children still do not have a will.
                        </p>
                        <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/70">
                            Only approximately{" "}
                            <span className="font-mono text-gold">24–36%</span>{" "}
                            of relevant cohorts currently have basic estate
                            planning documents in place. HEIR&apos;s $88 guided
                            conversation is designed specifically for this
                            large, underserved group.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
